import type { $ } from "../../../dom";
import { Input, type InputOptions } from "../../core";

export type SelectInputOptions<T> = InputOptions<T> & {};

export abstract class SelectInput<TData = string> extends Input<
  string | null,
  TData
> {
  constructor($: $, options: SelectInputOptions<string>) {
    const { ...superOptions } = options;

    super($, superOptions);

    this.$input.on("input:relkit-input", () => this.triggerInput());
    this.$input.on("change:relkit-input", () => this.triggerChange());
  }

  get $options(): $ {
    return this.$input.find("option");
  }

  hasOptionValue(value: string): boolean {
    return this.$options.eq(`[value="${value}"]`).length > 0;
  }

  get isActive(): boolean {
    return this.$input.value !== "";
  }

  get value(): string | null {
    return this.$input.value || null;
  }

  set value(value: string | null) {
    if (value && !this.hasOptionValue(value)) {
      value = null;
    }

    this.$input.value = value || "";

    this.triggerInput();
    this.triggerChange();
  }
}
